import { render } from "./ProjectManagementPage.vue?vue&type=template&id=b3582d46&ts=true"
import script from "./ProjectManagementPage.vue?vue&type=script&lang=ts"
export * from "./ProjectManagementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__